import { MSPCase } from '@cms-max/medicare-api-sdk'
import { Card } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'
import BsiButton from 'containers/Claims/components/BsiButton'

type MspSummaryCardProps = {
  caseSummary: MSPCase
  className?: string
  classType?: 'msa' | 'msp'
}
export const MspSummaryCard = ({
  caseSummary,
  className,
  classType
}: MspSummaryCardProps) => {
  const { t } = useTranslation('msp', { keyPrefix: 'caseCard' })
  const { caseDate, caseID, caseType } = caseSummary
  const isMSA = classType === 'msa'
  const urlSwap = isMSA ? process.env.REACT_APP_WCMSA_BSI_URL : process.env.REACT_APP_MSPRP_BSI_URL
  return (
    <Card className={className}>
      <div className="ds-u-padding--3 my-c-msp-card-summary ds-u-display--flex ds-u-flex-wrap--wrap my-u-gap--8 my-u-lg-gap--24 ds-u-align-items--center" data-testid="msp-summary-card">
        <dl className="my-c-msp-card-info ds-u-display--flex ds-u-flex-wrap--wrap ds-u-justify-content--between my-u-basis--full my-u-lg-basis--auto my-u-gap--8 my-u-lg-gap--12 my-u-flex-grow-1 ds-u-margin--0">
          <div className="my-u-basis--full my-u-md-basis--auto">
            <dt>{t('date')}</dt>
            <dd className="ds-u-margin--0 ds-text-body--lg ds-u-font-weight--semibold">{caseDate}</dd>
          </div>

          <div className="my-u-basis--full my-u-md-basis--2/5">
            <dt>{t('caseType')}</dt>
            <dd className="ds-u-margin--0 ds-text-body--lg ds-u-font-weight--semibold">{caseType}</dd>
          </div>

          <div className="my-u-basis--full my-u-md-basis--auto">
            <dt>{t('caseId')}</dt>
            <dd className="ds-u-margin--0 ds-text-body--lg ds-u-font-weight--semibold">{caseID}</dd>
          </div>
        </dl>
        <div className="my-u-basis--full my-u-md-basis--auto">
          <BsiButton
            data-testid={`${caseID}-case-button`}
            className="ds-c-button ds-c-button--solid ds-c-button--alternate"
            aria-label={t('button')}
            classType={classType}
            caseId={caseID}
            siteActivityProps={{
              core: {
                component: classType === 'msa' ? 'Medicare Set Aside' : 'Medicare Secondary Payer',
                elementId: classType === 'msa' ? 'msa_seedetails_click' : 'msp_seedetails_click',
                coreClickData: {
                  linkText: t('button'),
                  linkUrl: urlSwap || `https://bsi.medicare.gov/fed/idp/initiatesso?providerid=${classType === 'msa' ? 'WCMSA_PRO' : 'MSPRP_PRO'}`
                }
              }
            }}
              >
              {t('button')}
          </BsiButton>
        </div>
      </div>
    </Card>
  )
}
